import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import LoadingPage from "../Error/LoadingPage/LoadingPage";

const GuestRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <LoadingPage/>; // while checking user

  return user ? <Navigate to="/profile" /> : children;
};

export default GuestRoute;
